function SpanGold({ children }) {
  return <span className='text-gold'>{children}</span>;
}

export default SpanGold;
